import React, { useRef, useState } from "react";
import AuthLayout from "./layout";
import { Link, useParams, useNavigate } from "react-router-dom";
import { API_URL, APIS, URLS } from "../../_config";
import { Controller, useForm } from "react-hook-form";
import Error from "../../components/formFieldError";
import toast from "react-hot-toast";

import { useUserApi } from "../../store/api/hooks/userApiHook";
import Icon from "../../components/icons";

const ResetPassword: React.FC = () => {
  const userApi: any = useUserApi();
  const navigate = useNavigate();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const params: any = useParams();
  const emailData = params.email;

  const userAPI: any = useUserApi();
  const [email, setEmail] = useState(emailData);
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const submitResetPassword = (params: any) => {
    return new Promise((resolve, reject) => {
      userApi.resetPassword(
        params,
        (msg: any, resp: any) => {
          resolve(msg);
          let resetValues = { name: "", email: "", message: "", phone: "" };
          reset(resetValues);
        },
        (msg: any) => {
          // Handle error

          reject(msg);
        }
      );
      // fetch(APIS.AUTH.REGISTRATION, {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify(params),
      // })
      //   .then((response) => response.json())
      //   .then((resp) => {
      //     if (resp?.status == 200) {
      //       console.log("==msg==", resp);
      //       resolve(resp.message);
      //       let resetValues = { name: "", email: "", message: "" };
      //       reset(resetValues);
      //       // Reset reCAPTCHA
      //     } else {
      //       console.log("==errormsg==", resp);

      //       reject(resp.message);
      //     }
      //   })
      //   .catch((error) => {
      //     console.log("====xxyz===", error);
      //     toast.error(error.message);
      //     // Handle error
      //     console.error("Error:", error);
      //     reject(error.message);
      //   });
    });
  };
  const saubmitFormHandler = (data: any) => {
    toast.promise(submitResetPassword(data), {
      loading: "Submitting...",
      success: (msg: any) => {
        navigate(URLS.LOGIN);
        return <b>{msg}</b>;
      },
      error: (msg: any) => <b>{msg}</b>,
    });
  };

  // const handleSubmit = (event: React.FormEvent) => {
  //     event.preventDefault();
  //     userAPI.login({},(message:any, resp:any)=>{},(message:any, error:any)=>{});
  //     console.log('Email:', email);
  //     console.log('Password:', password);
  // };

  return (
    <AuthLayout>
      <div className="login_logo">
        <a href="javascript:void(0);">
          <img src="/assets/images/login/logo.png" />
        </a>
      </div>
      <h3>Mortgage Support.</h3>
      <p>Reset your password</p>
      <form onSubmit={handleSubmit(saubmitFormHandler)}>
        <div className="form-group mb-3">
          <Controller
            defaultValue={emailData}
            control={control}
            name="token"
            render={({ field: { onChange, onBlur, value, name, ref } }) => (
              <input
                type="hidden"
                name={name}
                onChange={onChange}
                onBlur={onBlur}
                value={emailData}
                className="form-control"
                placeholder="Enter your Email Id"
              />
            )}
          />
        
        
        </div>
        <div className="form-group mb-2">
          <Controller
            defaultValue={""}
            control={control}
            name="password"
            rules={{
              required: "Password is required",

              minLength: {
                value: 6,
                message: "Password must have at least 6 characters",
              },
              maxLength: {
                value: 16,
                message: "must be less than 16 characters in length",
              },
              pattern: {
                value:
                  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
                message:
                  "Must contain uppercase, lowercase, number, and special character",
              },
            }}
            render={({ field: { onChange, onBlur, value, name, ref } }) => (
              <input
                type={showPassword ? "text" : "password"}
                name={name}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                className="form-control"
                placeholder="Enter your Password"
              />
            )}
          />
          <span className="input_icon">
            <Icon
              name={showPassword ? "eye" : "eye-off"}
              onClick={() => setShowPassword(!showPassword)}
            />{" "}
          </span>
          <Error error={errors["password"]} />
        </div>
        <div className="form-group mb-2">
          <Controller
            defaultValue={""}
            control={control}
            name="c_password"
            rules={{
              required: "Confirm Password is required",
              minLength: {
                value: 6,
                message: "Password must have at least 6 characters",
              },
            }}
            // rules={{ required: 'Confirm Password is required', validate: (value) => value === control.getValues('password') || 'The passwords do not match' }}
            render={({ field: { onChange, onBlur, value, name, ref } }) => (
              <input
                type={showConfirmPassword ? "text" : "password"}
                name={name}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                className="form-control"
                placeholder="Enter your confirm password"
              />
            )}
          />
          <span className="input_icon">
            <Icon
              name={showConfirmPassword ? "eye" : "eye-off"}
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            />{" "}
          </span>
          <Error error={errors["confirm_password"]} />
        </div>

        <button type="submit" className="loginBtn">
          Submit
        </button>
      </form>
      <div className="create_account">
        Go To <Link to={URLS.LOGIN}>Login</Link>
      </div>
      <div className="login_copyright">
        © <script>document.write(new Date().getFullYear())</script> Mortgage
        Support | <a href="javascript:void(0);"> Policy</a> |{" "}
        <a href="javascript:void(0);"> Terms</a>
      </div>
    </AuthLayout>
  );
};

export default ResetPassword;
